import { connect } from 'react-redux'

import { SearchViaHubSpotModal } from '@components/account/edit'

import coordinators from '@coordinators'
import presenters from '@presenters'
import services from '@services'
import { HandleError } from '@coordinators/composed'

const mapDispatchToProps = () => {
  const { AccountService, RestService, HubspotCompanyService, UIService } =
    services
  const { ConfirmationModal } = UIService
  const { NewManualAccount, NewAccountFromHubspot, GetHubspotCompanyById } =
    coordinators
  const { pResponseCreateAccountFromHubspot, pResponseFullHubspotCompany } =
    presenters.Api

  const newManualAccount = NewManualAccount({
    AccountService,
    UIService,
    HubspotService: HubspotCompanyService,
  })
  const newAccountFromHubspot = NewAccountFromHubspot({
    AccountService,
    HubspotService: HubspotCompanyService,
    UIService,
    pResponseCreateAccountFromHubspot,
  })

  const getHubspotCompanyById = GetHubspotCompanyById({
    RestService,
    pResponseFullHubspotCompany,
    endpoint: 'companies',
    HandleError,
  })
  const close = UIService.EditAccount.closeSearchViaHubSpot

  return {
    close,
    confirmationModal: ConfirmationModal,
    getHubspotCompanyById,
    newAccountFromHubspot,
    newManualAccount,
  }
}

export default connect(undefined, mapDispatchToProps)(SearchViaHubSpotModal)
